import axios from 'axios';
import { API } from '../../config/api';

export const FETCH_COUPON_DATA_REQUEST = 'FETCH_COUPON_DATA_REQUEST';
export const FETCH_COUPON_DATA_SUCCESS = 'FETCH_COUPON_DATA_SUCCESS';
export const FETCH_COUPON_DATA_FAILED = 'FETCH_COUPON_DATA_FAILED';

export const fetchCouponDataRequest = () => ({
  type: FETCH_COUPON_DATA_REQUEST,
});

export const fetchCouponDataSuccess = (coupons) => ({
  type: FETCH_COUPON_DATA_SUCCESS,
  payload: coupons,
});

export const fetchCouponDataFailed = (error) => ({
  type: FETCH_COUPON_DATA_FAILED,
  payload: error,
});

export const fetchCouponData = () => {
  return async (dispatch) => {
    try {
      dispatch(fetchCouponDataRequest());

      const response = await axios.get(`${API.coupon}`);
      dispatch(fetchCouponDataSuccess(response.data.coupons));
    } catch (error) {
      dispatch(fetchCouponDataFailed(error?.response?.data?.message || error.message));
    }
  };
};
